export default __webpack_public_path__ + "static/media/Textbooks.3f39088b.png";